import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import {
  AUTH_CLIENT_ID_WEB,
  GOOGLE_MAP_API_URL,
  GOOGLE_SPOT_AUTH_SCOPE,
  GOOGLE_SPOT_CLIENT_ID,
  GOOGLE_SPOT_GRANT_TYPE,
  GTM_KEY,
  GUEST_CLIENT_ID_WEB,
  LOGIN_PATH_NAME,
} from '@kfc-global/react-shared/config/config.constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib/i18N';
import { AnalyticsProviders } from '@kfc-global/react-shared/analytics/models/Event';
import ConfigManager from '@kfc-global/react-shared/config/config.manager';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { getWebAppVersionCall } from '@kfc-global/react-shared/redux/Actions/AppVersionAction';
import {
  deleteBasketsAction,
  removeAllCouponAction,
  removeAllItemAction,
  removeCouponAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { setErrorCode } from '@kfc-global/react-shared/redux/Actions/ErrorAction';
import { getTenantConfig, getTenantConfigUpdate } from '@kfc-global/react-shared/redux/Actions/TenantAction';
import PullToRefresh from 'atoms/PullToRefresh';
import {
  CONFIG_MIN_SUPPORTED_BROWSERS,
  DAILY_CART_STATUS_CHECK_FLAG,
  SESSION_STORAGE_KEYS,
  UNSUPPORTED_BROWSER,
  NETWORK_STATUS,
  LOCAL_STORAGE_KEYS,
  TENANT_DELIVERY_ADDRESS_MAPPING,
  FOREIGN_FONTS,
} from 'common/constants/SharedConstants';
import { AUTO_DETECT_CONSTANTS } from 'organisms/SearchStore/Constants/AutoDetectionConstants';
import { BrowserManager, ChannelManager } from 'common/manager';
import { getCmsClient, initCmsClient } from 'common/utilities/cmsClient';
import {
  createBasketData,
  displayToast,
  getAndCheck,
  getDataLayer,
  getDispositionTypeOnAPIFormat,
  getFilteredItems,
  isEmptyEvery,
  isMobileDevice,
  redirectToHomePage,
  isSupportedTenantCode,
  getTranslation,
  emptyFunction,
  getDeviceLanguage,
  isEventDisposition,
  findAllowedKey,
} from 'common/utilities/utils';
import { selectHeader } from 'context/selectors';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import { isCartExpired } from 'organisms/CartPage/Utils/cartPageUtils';
import { APPLIED } from 'organisms/CouponsLanding/Constants/CouponConstants';
import { getErrorMsg } from 'organisms/CouponsLanding/utils/CouponUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import WelcomeBackContainer from 'organisms/WelcomeBackModal/Container/WelcomeBackContainer';
import WorkerComponent from 'organisms/WorkerComponent/Container/WorkerComponent';
import PropTypes from 'prop-types';
import { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Alert, ALERT_TYPE } from 'atoms/Alert';
import TagManager from 'react-gtm-module';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'styles/main.scss';
import { UserOrderContext } from '../context/context';
import RouterInfo from './RouterInfo';
import { getAppConfigs } from '@kfc-global/react-shared/redux/Actions/AppConfigsActions';
import { setAfrigisApiKey } from '@kfc-global/react-shared/redux/Actions/AfriGisTokenAction';
import { Environments, HIDE_CONSOLE_LOGS } from './Constants';
import SharedApp from '@kfc-global/react-shared/App';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { useHistory } from 'react-router-dom';
import { initModulator } from 'common/utilities/GlobalModulatorUtils';
import LoadingBucket from 'atoms/LoadingBucket';
import { getSearchParameters, addRemoveInclass } from 'common/utilities/CheckoutUtils';
import subscribeToHarnessFeatureFlags from 'common/utilities/HarnessUtils';
import { getTranslationLanguage, getSafeConfig } from 'common/utilities/utils';
import AppShared from '@kfc-global/react-shared/App';
import BrazeHandler from 'app/BrazeHandler';
import { initDatadogRum } from '../datadog';
import {
  DATADOG_CLIENT_TOKEN,
  DATADOG_APPLICATION_ID,
  DATADOG_SITE,
  DATADOG_SERVICE,
  DATADOG_SESSION_REPLAY_SAMPLE_RATE,
  DATADOG_SESSION_SAMPLE_RATE,
  AFRIGIS_API_KEY,
} from '@kfc-global/react-shared/config/config.constants';
// Dynamically import font faces
const urlLangParam = new URLSearchParams(window.location.search)?.get('lang');
const previousLang = localStorage.getItem(LOCAL_STORAGE_KEYS?.USER_LANGUAGE);
if (urlLangParam && urlLangParam.toLowerCase() !== (previousLang || '').toLowerCase()) {
  sessionStorage.setItem('PENDING_LANG_PARAM', urlLangParam);
}
const userLanguage = urlLangParam || localStorage.getItem(LOCAL_STORAGE_KEYS?.USER_LANGUAGE);
const defaultLanguage = localStorage.getItem(LOCAL_STORAGE_KEYS?.DEFAULT_LANGUAGE);
const selectedLanguage = userLanguage ?? defaultLanguage?.key;
const fontCountry = FOREIGN_FONTS[selectedLanguage] || '';
// import(`../styles/fonts/_fonts${fontCountry}.scss`);
export const handleRefresh = pullToRefreshEnabled => {
  if (pullToRefreshEnabled) {
    window.location.reload();
    return true;
  }
  return false;
};

const cartCountCheck = (cartCount, cartCountRef, showCartToastInPDP) => {
  const reorderClickValue = JSON.parse(sessionStorage.getItem('reorderClick'));
  const addOnModalCartBtnClick = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.INDULGENT_ADDONS_CART_CLICK));
  if (cartCountRef != null && cartCount > cartCountRef) {
    !addOnModalCartBtnClick && !reorderClickValue && showCartToastInPDP && displayToast(cartCount - cartCountRef);
  }
};

export const hideConsoleLogs = hideLogs => {
  if (process?.env?.NODE_ENV?.toLowerCase() !== Environments.DEV && hideLogs?.trim()?.toLowerCase() === 'yes') {
    console.log = emptyFunction;
    console.error = emptyFunction;
    console.table = emptyFunction;
    console.warn = emptyFunction;
    console.debug = emptyFunction;
  }
};
export const App = ({ isConfigAvailable }) => {
  let userLoginFlag = useRef();
  const cartCountRef = useRef(null);
  const profileReducer = useSelector(data => data.profileReducer);
  const appConfigsReducer = useSelector(data => data.appConfigsReducer);
  const appEnvironment = appConfigsReducer?.response?.APP_ENVIRONMENT;
  const cartReducer = useSelector(data => data.cartReducer);
  const errorReducer = useSelector(data => data.errorReducer);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [isReturningUser, setIsReturningUser] = useState(false);
  const { INITIAL_DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const { AUTO_DETECTION_BUTTON_FLAG, GRANTED } = AUTO_DETECT_CONSTANTS;
  const { disposition = {} } = useSelector(selectHeader);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    analyticsProviders,
    defaultAnalyticsProviders,
    defaultLanguage,
    country: COUNTRY,
    allowedLanguages,
  } = useSelector(
    ({
      tenantReducer: {
        basic = {},
        analyticsProviders: { web: analyticsProviders = {} } = {},
        defaultAnalyticsProviders: { web: defaultAnalyticsProviders = {} } = {},
        country,
      } = {},
    }) => ({ ...basic, analyticsProviders, defaultAnalyticsProviders, country }),
  );
  const userLanguage = localStorage.getItem(LOCAL_STORAGE_KEYS?.USER_LANGUAGE);
  const selectedLanguage = userLanguage ?? defaultLanguage?.key;
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const appVersionReducerData = useSelector(data => data?.appVersionReducer?.response ?? null);
  const {
    allowRemoteWipeOut,
    componentOptions = { web: { pdp: {}, global: {}, cartPage: {}, storeSearch: {} } },
    useDeviceDefaultLanguage,
  } = useSelector(data => data.tenantReducer);
  const changeDefaultLanguage = useDeviceDefaultLanguage
    ? getDeviceLanguage(allowedLanguages, defaultLanguage)
    : defaultLanguage;
  let {
    web: {
      pdp: { showCartToastInPDP = false },
      coupons,
      global: { pullToRefreshEnabled = false, } = {},
      cartPage: { invalidCouponHide = false },
      storeSearch: { useAfriGis = false } = {},
    },
  } = componentOptions;
  const { userLocationAccessStatus } = useSelector(data => data.storesReducer);
  const { userLastActiveTime, cartData, isBasketLoading } = useSelector(data => data.cartReducer);
  const { discountLines = [], foodLines = [], id: basketId } = cartData || {};
  const [cartCount, setCartCount] = useState(reduce(cartData?.foodLines, (sum, number) => sum + number?.quantity, 0));
  const { tenantId, addHope, carryBag, deliveryAddressMapping = {} } = useSelector(data => data?.tenantReducer);
  const dataDogApplicationId = getSafeConfig(DATADOG_APPLICATION_ID);
  const dataDogClientId = getSafeConfig(DATADOG_CLIENT_TOKEN);
  const dataDogSite = getSafeConfig(DATADOG_SITE);
  const dataDogService = getSafeConfig(DATADOG_SERVICE);
  const dataDogSessionReplaySampleRate = parseInt(getSafeConfig(DATADOG_SESSION_REPLAY_SAMPLE_RATE), 10);
  const dataDogSessionSampleRate = parseInt(getSafeConfig(DATADOG_SESSION_SAMPLE_RATE), 10);
  sessionStorage.setItem('userId', profileReducer?.customerId);
  const dispatch = useDispatch();
  const history = useHistory();
  const isKentuckyFont = componentOptions?.web?.global?.isKentuckyFont;
  const afrigisApiKey = process?.env?.AFRIGIS_AUTH_KEY || getSafeConfig(AFRIGIS_API_KEY);

  const clearCartItemHandler = () => {
    localStorage.setItem(DAILY_CART_STATUS_CHECK_FLAG, new Date());
    if (discountLines.length > 0 && basketId) {
      let discountLinesId = discountLines.map(discItem => discItem.id);
      dispatch(
        removeAllCouponAction(
          {
            params: {
              basketId,
            },
            tenantId,
            shouldClearCart: true,
          },
          discountLinesId,
        ),
      );
    } else if (basketId) {
      dispatch(
        removeAllItemAction({
          basketId,
          tenantId,
        }),
      );
    }
  };

  useEffect(() => {
    setIsReturningUser(false);
  }, [userParams.localized]);

  useEffect(() => {
    if (
      dataDogSessionReplaySampleRate &&
      dataDogSessionSampleRate &&
      dataDogApplicationId &&
      dataDogClientId &&
      dataDogSite &&
      dataDogService
    ) {
      initDatadogRum(
        appEnvironment,
        dataDogSessionReplaySampleRate,
        dataDogSessionSampleRate,
        dataDogApplicationId,
        dataDogClientId,
        dataDogSite,
        dataDogService,
        profileReducer,
      );
    } else {
      console.log('Datadog RUM not initialized: missing required config variables');
    }
  }, [
    dataDogSessionReplaySampleRate,
    dataDogSessionSampleRate,
    appEnvironment,
    dataDogApplicationId,
    dataDogClientId,
    dataDogSite,
    dataDogService,
    profileReducer,
  ]);

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useLayoutEffect(() => {
    if (isConfigAvailable) {
      const gtmId = config(GTM_KEY);
      const tagManagerArgs = {
        gtmId: gtmId,
      };
      TagManager.initialize(tagManagerArgs);
    }
    useAfriGis && dispatch(setAfrigisApiKey(afrigisApiKey));
  }, [isConfigAvailable]);

  /**
   * Load google map API asynchronouslyr
   */
  useEffect(() => {
    if (isConfigAvailable && !useAfriGis) {
      const googleMapApiUrl = config(GOOGLE_MAP_API_URL);
      // const AfriMapApiUrl = config('https://afrigis.services/');
      if (googleMapApiUrl) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        const googleMapchangeLangUrl = new URL(googleMapApiUrl);
        googleMapchangeLangUrl.searchParams.set('language', selectedLanguage);
        script.src = googleMapchangeLangUrl.toString();
        window.initMap = () => {
          console.log('Google map has been loaded successfully');
        };
        document.head.appendChild(script);
      }
    }
    // Once the page loads we should remove the loading animation
    const loader = document.getElementsByClassName('home-loading-animation');
    if (loader.length) {
      loader[0].style.display = 'none';
    }
  }, [isConfigAvailable, selectedLanguage, useAfriGis]);

  useEffect(() => {
    cartCountRef.current = cartCount;
    let addHopeCarryBag = getAndCheck(addHope, carryBag);
    if (addHopeCarryBag) {
      let filteredFoodLineData = getFilteredItems(foodLines, addHope, carryBag);
      let DisplayedFoodLineData = filteredFoodLineData?.filter(foodItems => foodItems?.item?.isHidden !== true);
      setCartCount(reduce(DisplayedFoodLineData, (sum, item) => sum + item?.quantity, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(foodLines)]);

  useEffect(() => {
    const serviceType = isEventDisposition(userOrderState?.dispositionNew?.type);
    if (serviceType) {
      showCartToastInPDP = true;
    }
    cartCountCheck(cartCount, cartCountRef?.current, showCartToastInPDP);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartCount]);

  const getAnalyticsInstancesForProviders = providers =>
    providers?.map(p => {
      if (p === AnalyticsProviders?.GTM) {
        return { GTM: getDataLayer };
      }
      return null;
    });

  useEffect(() => {
    if (!isEmpty(analyticsProviders) && !isEmpty(defaultAnalyticsProviders)) {
      const analyticsInstances = getAnalyticsInstancesForProviders(analyticsProviders);
      AnalyticsService.registerAnalyticsProviders(analyticsInstances);
      AnalyticsService.defaultAnalyticsProviders = defaultAnalyticsProviders;
    }
  }, [analyticsProviders, defaultAnalyticsProviders]);

  useEffect(() => {
    toast.dismiss();
  }, [window?.location?.pathname]);

   useEffect(() => {
     if (isKentuckyFont && selectedLanguage !== 'ja-JP' && selectedLanguage !== 'th-TH') {
      import(`../styles/fonts/_fontsnewfont.scss`).catch(() => {});
      document.body.classList.add(`market-new-css-font-and-icons`);
    } else {
      import(`../styles/fonts/_fonts${fontCountry}.scss`).catch(() => {});
      document.body.classList.remove(`market-new-css-font-and-icons`);
    }
    return () => document.body.classList.remove(`market-new-css-font-and-icons`);
  }, [isKentuckyFont, selectedLanguage, fontCountry]);

  useEffect(() => {
    localStorage.setItem(TENANT_DELIVERY_ADDRESS_MAPPING, JSON.stringify(deliveryAddressMapping));
  }, [deliveryAddressMapping]);

  useEffect(() => {
    !!Object.keys(disposition).length &&
      userOrderStateDispatch({ type: INITIAL_DISPOSITION_DATA, value: { disposition } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disposition]);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.DEFAULT_LANGUAGE, JSON.stringify(changeDefaultLanguage));
    getTranslation({ defaultLanguage: changeDefaultLanguage }, userOrderStateDispatch, allowedLanguages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage, COUNTRY]);


  useEffect(() => {
    if (userOrderState?.setGlobalError) {
      throw new Error('Invalid translation');
    }
  }, [userOrderState?.setGlobalError]);

  useEffect(() => {
    if (allowRemoteWipeOut) {
      dispatch(
        getWebAppVersionCall({
          object: getCmsClient(),
          contentFull: {
            content_type: 'appMetaData',
            include: '5',
          },
        }),
      );
    }
  }, [dispatch, allowRemoteWipeOut]);

  useEffect(() => {
    const webAppVersion = localStorage.getItem(LOCAL_STORAGE_KEYS.WEB_APPVERSION);
    if (!webAppVersion && appVersionReducerData?.webAppVersion) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.WEB_APPVERSION, appVersionReducerData?.webAppVersion);
    } else if (appVersionReducerData?.webAppVersion > Number(webAppVersion)) {
      setTimeout(() => {
        window.localStorage.clear();
        window.location.reload();
      }, 2000);
    }
  }, [appVersionReducerData]);

  useEffect(() => {
    userLoginFlag.current = userParams.loggedIn;
  }, [userParams.loggedIn]);

  useEffect(() => {
    if (userParams.localized && userLocationAccessStatus === GRANTED && window?.google?.maps) {
      userOrderStateDispatch({ type: AUTO_DETECTION_BUTTON_FLAG, value: { autoDetectionClicked: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window?.google]);

  // check for invalidate cart for member user
  useEffect(() => {
    if (userParams.loggedIn && !isBasketLoading && cartData?.id && isCartExpired(userLastActiveTime)) {
      deleteCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderState?.dispositionNew, userLastActiveTime, userParams]);

  // Remove invalidated coupons
  useEffect(() => {
    const invalidCoupons = cartReducer?.cartData?.discountLines?.filter(obj => obj?.status?.name !== APPLIED);
    if (!isEmpty(invalidCoupons) && coupons?.showErrorToast && invalidCouponHide) {
      const errorMsg = getErrorMsg(invalidCoupons?.[0]);
      const hideToast = !window?.location?.pathname?.includes('cart');
      errorMsg &&
        hideToast &&
        toast.dark(
          <div data-testid='invalid-coupons-toast' className='img-text-div'>
            <span className='text'>{errorMsg}</span>
          </div>,
          {
            hideProgressBar: true,
            position: toast.POSITION.BOTTOM_CENTER,
          },
        );
      dispatch(
        removeCouponAction({
          basketId: cartReducer?.cartData?.id,
          tenantId,
          couponCode: invalidCoupons?.[0]?.couponCode,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartReducer?.cartData?.discountLines, cartReducer?.cartData?.id, dispatch, tenantId]);

  useEffect(() => {
    // To detect and show generic error toast message only in development
    process?.env?.NODE_ENV === 'development' &&
      errorReducer?.errorCode &&
      toast.dark(
        <div data-testid='generic-error-toast' className='img-text-div'>
          <span className='text'>{`${translateWithI18Next('somethingWentWrong')} (${errorReducer?.errorCode})`}</span>
        </div>,
        {
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
          onClose: () => dispatch(setErrorCode(undefined)),
        },
      );

    if (errorReducer?.errorCode === NETWORK_STATUS?.UNAUTHORIZED) {
      sessionStorage?.removeItem(LOCAL_STORAGE_KEYS?.ORDER_TRACKING);
      redirectToHomePage({ history });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, errorReducer?.errorCode]);

  async function deleteCart() {
    let { dispositionNew } = userOrderState ?? {};
    dispositionNew = isEmptyEvery(dispositionNew)
      ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS?.DISPOSITION_NEW))
      : dispositionNew;
    if (userParams.localized) {
      const params = {
        storeInfo: dispositionNew?.store,
        dispositionType: getDispositionTypeOnAPIFormat(dispositionNew?.type),
      };
      let obj = await createBasketData(params.storeInfo, params.dispositionType, profileReducer.customerId);
      tenantId &&
        dispatch(
          deleteBasketsAction({ basketId: cartData.id }, true, {
            data: obj,
            tenantId,
          }),
        );
    }
  }

  useEffect(() => {
    if (useDeviceDefaultLanguage) {
      AppShared.language = getTranslationLanguage({ defaultLanguage: changeDefaultLanguage }, allowedLanguages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location]);

  const isPullableFn = () => {
    if (userOrderState?.scheduleOrderData?.showScheduleOrderCatering) {
      return false;
    }
    return !userOrderState?.searchStoreData?.showSearchStore;
  };

  if (!BrowserManager.isBrowserSupported) {
    return (
      <Alert type={ALERT_TYPE.danger} className='appNotAvailable'>
        {translateWithI18Next(UNSUPPORTED_BROWSER) ??
          'Unsupported Browser. Please use following browsers to use the app.'}
        <br />
        {JSON.stringify(BrowserManager.minSupportedBrowsers)}
      </Alert>
    );
  }
  const shouldShowWelcomeBackModal = window?.location?.pathname === '/' || window?.location?.pathname === '/menu';
  return (
    <PullToRefresh
      isPullable={isMobile && isPullableFn()}
      className='pullToRefresh'
      onRefresh={() => handleRefresh(pullToRefreshEnabled)}
      refreshingContent={null}
      pullingContent={null}
      pullDownThreshold={75}
      maxPullDownDistance={75}
    >
      <RouterInfo />

      {shouldShowWelcomeBackModal && (
        <WelcomeBackContainer
          setIsReturningUser={setIsReturningUser}
          isReturningUser={isReturningUser}
          isLocalized={userParams.localized}
        />
      )}

      {isSupportedTenantCode() && (
        <WorkerComponent
          clearCartItemHandler={clearCartItemHandler}
          setIsReturningUser={setIsReturningUser}
          cartCount={cartCount}
          userParams={userParams}
        />
      )}
      {userOrderState?.showBucketLoader && <LoadingBucket />}
      <BrazeHandler />
    </PullToRefresh>
  );
};

App.propTypes = {
  isConfigAvailable: PropTypes.bool,
};

App.defaultProps = {
  isConfigAvailable: false,
};

const AppWrapper = () => {
  const { SET_FORCERELOAD } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch } = useContext(UserOrderContext);

  const {
    tenantReducer: {
      tenantId,
      componentOptions: { web: { global: { supportGooglePaySpot = false } = {} } = {} } = {},
    } = {},
    appConfigsReducer: { response: appConfigResponse, clientId } = {},
    profileReducer: { customerId = '' } = {},
  } = useSelector(({ tenantReducer, appConfigsReducer, profileReducer }) => ({
    tenantReducer,
    appConfigsReducer,
    profileReducer,
  })) ?? {};
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const [isConfigAvailable, setConfigAvailable] = useState(false);
  const [isCmsInitialized, setCmsInitialized] = useState(false);
  const appConfigResponseStr = JSON.stringify(appConfigResponse) ?? '{}';

  const dispatch = useDispatch();
  useEffect(() => {
    const tenantCode = process?.env?.REACT_APP_TENANT_CODE;
    dispatch(getTenantConfig(tenantCode));
    dispatch(getAppConfigs({ tenantCode }));
    initModulator();
  }, [dispatch]);

  useEffect(() => {
    if (tenantId && clientId && !isEmpty(JSON.parse(appConfigResponseStr))) {
      ConfigManager.setEnvConfigs({
        responseStr: appConfigResponseStr,
        tenantId,
        clientId,
      });

      console.log(`AppConfig: isConfigAvailable? ${ConfigManager.isConfigAvailable}`);

      BrowserManager.bind(config(CONFIG_MIN_SUPPORTED_BROWSERS));
      hideConsoleLogs(config(HIDE_CONSOLE_LOGS));
      SharedApp.initialize();
      SharedApp.envVars = {
        authParams: {
          memberClientId: config(AUTH_CLIENT_ID_WEB),
          guestClientId: config(GUEST_CLIENT_ID_WEB),
        },
      };
      const authParams = SharedApp.envVars?.authParams;
      if (supportGooglePaySpot && !isEmpty(authParams)) {
        console.log('Tenant supports google pay spot, setting spot configs');
        SharedApp.envVars.authParams = {
          ...authParams,
          googleClientId: config(GOOGLE_SPOT_CLIENT_ID),
          googleGrantType: config(GOOGLE_SPOT_GRANT_TYPE),
          googleAuthScope: config(GOOGLE_SPOT_AUTH_SCOPE),
        };
      }
      const isValidAccessToken = AuthManager?.getInstance()?.isValidAccessToken;
      const preventBootstrap =
        window?.location?.pathname?.includes(config(LOGIN_PATH_NAME)) && window?.location?.search?.includes('code');
      if (!isConfigAvailable) {
        ((userParams.loggedIn && !isValidAccessToken) || (!userParams.loggedIn && !preventBootstrap)) &&
          AuthManager.getInstance().bootstrapAuthentication();

        setConfigAvailable(ConfigManager.isConfigAvailable);
      }
      dispatch(getTenantConfigUpdate({ tenantId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, appConfigResponseStr, clientId, tenantId]);

  useEffect(() => {
    if (dispatch && appConfigResponseStr && !isEmpty(JSON.parse(appConfigResponseStr)) && isConfigAvailable) {
      subscribeToHarnessFeatureFlags(dispatch, customerId);
    }
  }, [dispatch, appConfigResponseStr, customerId, isConfigAvailable]);

  useLayoutEffect(() => {
    console.log('isConfigAvailable', isConfigAvailable);
    isConfigAvailable &&
      (async () => {
        const space = await initCmsClient(window.location.search);
        console.log('contentful has been initialized, space: ', space?.name);
        setCmsInitialized(true);
      })();
  }, [isConfigAvailable, userOrderStateDispatch]);

  useEffect(() => {
    ChannelManager.BindUserAgent();
    userOrderStateDispatch({
      type: SET_FORCERELOAD,
      value: { forceReload: true },
    });
  }, [SET_FORCERELOAD, userOrderStateDispatch]);

  /* Adding continue calss on loading animation during redirection form external to checkout for 3ds payment*/
  useEffect(() => {
    const { redirectResult } = getSearchParameters(window.location.search);
    redirectResult && addRemoveInclass(true);
  }, []);

  return isCmsInitialized ? <App isConfigAvailable={isConfigAvailable} /> : <></>;
};

export default AppWrapper;
